module.exports = __webpack_public_path__ + "static/revat-team_3_mobile-8ec92d96f6a8d409bbe1c2fc756bb077.jpg";